// Floating WhatsApp chat button — opens wa.me link with context-aware prefilled message
import { useLang } from "../contexts/LangContext";
import { useWhatsAppUrl } from "../lib/whatsapp";

const TOOLTIPS = {
  de: "Chat starten · +49 175 8802646",
  en: "Start chat · +49 175 8802646",
  ar: "ابدأ المحادثة · ‎+49 175 8802646"
};

export default function WhatsAppButton() {
  const { lang } = useLang();
  const tip = TOOLTIPS[lang] || TOOLTIPS.de;
  const href = useWhatsAppUrl(lang);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-5 start-5 z-50 group"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      {/* Main button */}
      <span className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] shadow-xl shadow-[#25D366]/30 hover:bg-[#1EBE5C] transition-all duration-200 hover:scale-105">
        <svg viewBox="0 0 32 32" className="w-7 h-7 sm:w-8 sm:h-8 text-white fill-current" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.834 3.41 4.769 4.355.616.302 2.035.875 2.722.875.847 0 2.85-.875 3.196-1.677.171-.43.171-.802.071-.946-.114-.157-.215-.215-.487-.358-.473-.243-1.39-.686-1.892-.686zM24.476 7.587C22.293 5.388 19.272 4.157 16.16 4.157c-6.484 0-11.832 5.27-11.832 11.754 0 2.054.529 4.067 1.567 5.847L4 28.272l6.602-1.724a11.93 11.93 0 0 0 5.56 1.401h.014c6.484 0 11.832-5.275 11.832-11.76 0-3.108-1.358-6.115-3.532-8.601zM16.176 26.029h-.014c-1.84 0-3.65-.487-5.215-1.418l-.372-.215-3.86 1.017 1.03-3.762-.244-.387a9.804 9.804 0 0 1-1.503-5.232c0-5.42 4.4-9.805 9.805-9.805 2.605 0 5.062 1.017 6.906 2.865a9.71 9.71 0 0 1 2.85 6.94c-.014 5.404-4.414 9.804-9.819 9.804z"/>
        </svg>
      </span>
      {/* Tooltip on hover */}
      <span className="hidden lg:block absolute bottom-1/2 translate-y-1/2 start-full ms-3 px-3 py-2 bg-[#090A0B] text-white text-xs font-bold whitespace-nowrap rounded-sm opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        {tip}
      </span>
    </a>
  );
}
